import dayjs from "dayjs";

interface ExportToCSVParams<T> {
  data: T[];
  fileName: string;
  headers?: string[];
}

export const exportToCSV = <T extends Record<string, any>>({
  data,
  fileName,
  headers,
}: ExportToCSVParams<T>) => {
  if (!data?.length) return;

  const csvHeaders = headers || Object.keys(data[0]);

  const rows = data.map((row) =>
    csvHeaders
      .map((header) => {
        const value = row[header];
        return `"${String(value ?? "").replace(/"/g, '""')}"`;
      })
      .join(","),
  );

  const csvContent = [csvHeaders.join(","), ...rows].join("\n");

  const blob = new Blob([csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = `${fileName}_${dayjs().format("YYYYMMDD_HHmmss")}.csv`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};
